export enum Endpoints {
    Configurations = '/application-configurations',
    Projects = '/projects'
}
